<template>
  <v-card class="mt-4 card-pad mx-auto" style="z-index: 10000" width="900px">
    <div class="d-flex justify-center my-3">
      <h2 class="ml-5">Dados Gerais</h2>
    </div>

    <v-divider class="ma-6 my-2"></v-divider>

    <v-window v-model="step" touchless>
      <v-window-item v-if="isLimitExceeded">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="error">mdi-alert-circle</v-icon>
          <span style="display: block; margin-top: 10px; font-size: 1.2rem"
            >O limite de registros para este link foi atingido.</span
          >
          <span style="display: block; margin-top: 5px; font-size: 1rem"
            >Entre em contato com o administrador para mais informações.</span
          >
        </div>
      </v-window-item>
      <v-window-item v-else :value="0">
        <v-form
          class="form"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
        >
          <v-row class="ma-0 mx-6" dense>
            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('E-mail') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="email"
                :rules="emailRules"
                required
                background-color="#F5F5F5"
                class="rounded-lg"
                name="email"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Nome') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="name"
                :rules="nameRules"
                required
                background-color="#F5F5F5"
                class="rounded-lg"
                name="name"
                outlined
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Telefone') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="phoneNumber"
                v-mask="['(##) ####-####']"
                name="phone"
                outlined
                background-color="#F5F5F5"
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
              <label class="label">{{ $t('Celular') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="cellPhoneNumber"
                v-mask="['(##) #####-####']"
                :rules="cellPhoneNumberRules"
                name="cellphone"
                outlined
                background-color="#F5F5F5"
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0" v-if="!isSSO">
              <label class="label">{{ $t('Senha') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="password"
                autocomplete="nope"
                :rules="[
                  (v) => this.isEditing || !!v || 'Senha requerida',
                  (v) =>
                    this.password === '' ||
                    /\d/.test(v) ||
                    'Mínimo de um número',
                  this.password === '' || minLength(this.password),
                  this.password === '' || specialCharacters(this.password),
                  this.password === '' || uppercaseLetter(this.password),
                ]"
                type="password"
                required
                name="password"
                outlined
                background-color="#F5F5F5"
                class="rounded-lg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="pb-0" v-if="!isSSO">
              <label class="label">{{ $t('Confirmação da senha') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="passwordConfirmation"
                autocomplete="nope"
                :rules="[
                  (v) =>
                    this.password === '' ||
                    this.isEditing ||
                    !!v ||
                    'Confirmação de senha requirida',
                  this.password === this.passwordConfirmation ||
                    'Senha não confere',
                ]"
                type="password"
                required
                name="confirmPassword"
                outlined
                background-color="#F5F5F5"
                class="rounded-lg"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon size="60" color="success">
            mdi-checkbox-marked-circle
          </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              isEditing
                ? $t('Usuário atualizado com sucesso!')
                : $t('Usuário cadastrado! Já pode acessar o Fix 👋')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mb-6 mt-2 mx-8"></v-divider>

    <div class="d-flex mx-6">
      <v-spacer></v-spacer>
      <v-btn
        v-if="!isLimitExceeded"
        depressed
        class="primary-button mr-0"
        @click="confirmEmail"
        :loading="loading"
      >
        Adicionar
      </v-btn>
    </div>
    <v-dialog
      v-model="showVerificationModal"
      max-width="500px"
      content-class="no-scroll"
      persistent
    >
      <v-card style="overflow: hidden">
        <v-row class="pa-4">
          <v-col cols="12" class="py-0">
            <v-card-title class="headline">
              <h4 class="mb-3">Confirmação de E-mail</h4>
            </v-card-title>
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-card-text>
              <label class="label">{{ $t('Código de verificação') }}</label>
              <v-text-field
                v-model="verificationCode"
                hide-details="auto"
                required
                background-color="#F5F5F5"
                class="rounded-lg"
                outlined
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-card-actions class="d-flex justify-end">
              <v-btn
                depressed
                class="secondary-button ml-2"
                @click="closeVerificationCodeModal"
              >
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                class="primary-button my-0"
                @click="registerClient"
                :loading="loading"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

@media (max-width: 600px) {
  .v-card__text {
    padding: 0;
  }
}
</style>

<script>
import ApiService from '../../../services/ApiService'

export default {
  data: () => ({
    step: 0,
    apiService: new ApiService(),
    loading: false,
    loader: false,
    firstValid: '',
    isEditing: null,
    password: '',
    passwordConfirmation: '',
    email: '',
    name: '',
    phoneNumber: '',
    cellPhoneNumber: '',
    showVerificationModal: false,
    verificationCode: '',
    isLimitExceeded: false,
    isSSO: false,

    emailRules: [
      (v) => !!v || 'E-mail requerido',
      (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
    ],
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    cellPhoneNumberRules: [
      (v) => !!v || 'Celular requerido',
      (v) => (v && v.length > 14) || 'Celular inválido',
    ],
  }),

  async created() {
    this.getLinkById()
  },

  computed: {},

  methods: {
    async next() {
      if (this.step === 0) {
        this.step += 1
      } else {
        this.closeDialog()
      }
    },

    async registerClient() {
      this.loading = true
      const linkId = this.$route.query.id

      await this.apiService
        .post('User/register/by-link', {
          linkId: linkId,
          name: this.name,
          email: this.email,
          password: this.password,
          cellPhoneNumber: this.cellPhoneNumber,
          phoneNumber: this.phoneNumber,
          code: this.verificationCode,
        })
        .then((response) => {
          if (response.statusCode === 200) {
            this.$toast.success('Usuário cadastrado! Já pode acessar o Fix 👋')
            this.$router.push('/auth')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },

    async getLinkById() {
      await this.apiService
        .get(`User/get-by-id/${this.$route.query.id}`)
        .then((response) => {
          if (
            response.content.currentRegistrations >=
            response.content.maxRegistrations
          )
            this.isLimitExceeded = true

          this.isSSO = response.content.isSSO ?? false
          if (this.isSSO) {
            this.generateRandomPassword()
          }
        })
        .catch(() => {
          this.$toast.error(
            `Erro ao verificar o link: ${error.message || error}`
          )
        })
    },

    generateRandomPassword() {
      const length = 12
      const charset =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-='
      let password = ''
      for (let i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n))
      }
      this.password = password
      this.passwordConfirmation = password
    },

    async confirmEmail() {
      this.loading = true

      await this.apiService
        .post('User/send-confirm-email', {
          email: this.email,
        })
        .then((response) => {
          if (response.statusCode == 200) {
            this.$toast.success('E-mail enviado! Confira seu e-mail.')
            this.openVerificationModal()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    openVerificationModal() {
      this.showVerificationModal = true
    },

    closeVerificationCodeModal() {
      this.showVerificationModal = false
    },

    minLength(v) {
      if (v.length) {
        if (v.length < 8) {
          return 'Mínimo de 8 caracteres'
        }
      }
      return true
    },

    specialCharacters(v) {
      if (v.length) {
        const specialCharacters = /[!@#$%^&*()_+[\]{};:'"<>,.?/~\\-]/

        if (specialCharacters.test(v) == false)
          return 'Mínimo de um caractere especial'

        return true
      }
      return true
    },

    uppercaseLetter(v) {
      if (v.length) {
        const uppercaseLetter = /[A-Z]/

        if (uppercaseLetter.test(v) == false)
          return 'Mínimo de uma letra maiúscula'

        return true
      }
      return true
    },
  },
}
</script>
